/**
 * Type icon of an attachment, shared by the reading pane's attachment strip and the composer's
 * attachment chips (DESIGN.md T10/T11), so a file looks the same everywhere.
 */
import { FileArchiveIcon, FileIcon, FileImageIcon, FileSpreadsheetIcon, FileTextIcon, FileVideoIcon, MailIcon, type LucideIcon } from 'lucide-react';

const BY_EXTENSION: readonly (readonly [RegExp, LucideIcon])[] = [
  [/\.(png|jpe?g|gif|webp|bmp|svg|heic|tiff?)$/i, FileImageIcon],
  [/\.(pdf|txt|docx?|odt|rtf|md)$/i, FileTextIcon],
  [/\.(xlsx?|ods|csv)$/i, FileSpreadsheetIcon],
  [/\.(zip|7z|rar|gz|tgz|tar)$/i, FileArchiveIcon],
  [/\.(mp4|mov|avi|mkv|webm)$/i, FileVideoIcon],
  [/\.(eml|msg)$/i, MailIcon],
];

/** Icon by kind (attached message) or file name. */
export function attachmentIcon(name: string, kind: 'file' | 'message' = 'file'): LucideIcon {
  if (kind === 'message') return MailIcon;
  return BY_EXTENSION.find(([pattern]) => pattern.test(name))?.[1] ?? FileIcon;
}
